<form class="app-modal tw-flex tw-flex-col tw-gap-4 tw-text-right" [formGroup]="modalForm" (submit)="onSubmit()">
  <header class="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-text-center">
    <img [src]="svg ? svg : sharedService.EditSVG" alt="" class="tw-h-16 tw-w-auto" />
    <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">
      {{ modalHeader }}
    </h5>
  </header>

  <div class="tw-flex tw-flex-col tw-gap-2">
    <smsir-input-label>{{ modalText }}</smsir-input-label>
    <smsir-input-group>
      <input
        smsirInput
        formControlName="text"
        [maxLength]="inputConf?.maxLength ?? 128"
        [placeholder]="inputConf?.placeholder ?? ''"
        [type]="inputConf?.type ?? 'text'"
      />
    </smsir-input-group>
  </div>

  <div class="tw-flex tw-w-full tw-flex-wrap tw-justify-end tw-gap-2 max-md:tw-grid max-md:tw-grid-cols-2">
    <button
      type="button"
      smsir-button
      variant="text"
      size="sm"
      class="tw-min-w-0 md:tw-w-auto"
      (click)="onCancel()"
    >
      {{ modalCancelButton || 'بازگشت' }}
    </button>
    <button
      type="submit"
      smsir-button
      variant="secondary"
      size="sm"
      class="tw-min-w-0 md:tw-w-auto"
      [disabled]="modalForm.invalid"
    >
      {{ modalConfirmButton || 'تایید' }}
    </button>
  </div>
</form>
